import DealerCompare from 'components/admin/Users/DealerCompare'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { loadImportUsers, loadUsers } from 'redux/userAdmin'
import { Grid } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { users = [], importUsers = [] } = state.userAdmin
  return { users, importUsers }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadUsers,
      loadImportUsers,
    },
    dispatch
  )
}

class DealerCompareContainer extends React.Component {
  componentWillMount() {
    const { loadUsers, loadImportUsers } = this.props
    loadUsers()
    loadImportUsers()
  }

  render() {
    const {
      users,
      importUsers,
      match: { params = {} }, // react router
    } = this.props

    const importUser =
      importUsers.find((user) => user.id === Number(params.user_id)) || {}
    const user =
      users.find((user) => user.address_number === importUser.address_number) ||
      {}
    return (
      <Grid verticalAlign="middle">
        <Grid.Row>
          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={8}
            widescreen={8}>
            <DealerCompare user={user} importUser={importUser} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

DealerCompareContainer = connect(mapStateToProps, mapDispatchToProps)(
  DealerCompareContainer
)
export default DealerCompareContainer



// WEBPACK FOOTER //
// ./src/containers/admin/dealer_compare.jsx